import { useQuery } from "react-query";
import axios from "axios";
import { QueueScenarioAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";

export type TicketNumberMode =
  | "SERVICE_PREFIX"
  | "KEEP_SERVICE_PREFIX"
  | "BENEFIT_FLAG";

export type QueueScenarioSettingsDto = {
  branchQueueId: number;
  noShowTimeoutSeconds: number | null;
  autoDistributeEnabled: boolean;
  autoDistributeDelaySeconds: number;
  lcdRotationIntervalSeconds: number;
  ticketNumberMode: TicketNumberMode;
  regularTicketPrefix: string;
  benefitTicketPrefix: string;
  ticketNumberDigits: number;
  ticketNumberPadZeros: boolean;
};

export const useGetQueueScenarioSettings = (branchQueueId: number | null) => {
  return useQuery(
    ["queueScenarioSettings", branchQueueId],
    async () => {
      const { data } = await axios.get<QueueScenarioSettingsDto>(
        QueueScenarioAPI.getSettings(branchQueueId!),
        commonHeaders(),
      );
      return data;
    },
    { enabled: branchQueueId != null },
  );
};
